'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginLink = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginLink = exports.LoginLink = function (_BcReactComponent) {
  _inherits(LoginLink, _BcReactComponent);

  function LoginLink() {
    _classCallCheck(this, LoginLink);

    return _possibleConstructorReturn(this, (LoginLink.__proto__ || Object.getPrototypeOf(LoginLink)).apply(this, arguments));
  }

  _createClass(LoginLink, [{
    key: 'render',
    value: function render() {
      var handleLogin = this.props.handleLogin;

      return _react2.default.createElement(
        'a',
        { href: '/user/login', onClick: handleLogin, className: 'cp-login-link btn btn-primary', tabIndex: '0' },
        this.props.children
      );
    }
  }]);

  return LoginLink;
}(_baseBcReactComponent2.default);

LoginLink.propTypes = {
  handleLogin: _react.PropTypes.func.isRequired,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
};

exports.default = LoginLink;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/login-link/components/LoginLink.js
// module id = 1524
// module chunks = 1